// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__10eHK","screenContainer":"App_screenContainer__2cffN"};